import { render, staticRenderFns } from "./btn-group.vue?vue&type=template&id=6f37d3d0&scoped=true&"
import script from "./btn-group.vue?vue&type=script&lang=js&"
export * from "./btn-group.vue?vue&type=script&lang=js&"
import style0 from "./btn-group.vue?vue&type=style&index=0&id=6f37d3d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37d3d0",
  null
  
)

export default component.exports